import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopLeftCorner: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSquareArrowTopLeftCorner"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM7 13H8.5V9.56055L13 14.0605L14.0605 13L9.56055 8.5H13V7H7V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopLeftCorner;
